/*global _*/
import interact from 'interactjs'
import {floor, ceil, max, min, fv} from './config'

export default {
    data() {
        return {
            dragOffsetX: 0
        }
    },
    computed: {

    },
    watch: {

    },

    created() {
    },
    mounted() {
        this.initDraggers()
    },
    methods: {
        getContextPositions() {
            const context = this.els.context
            return {
                left: context.offsetLeft,
                width: context.clientWidth,
            }
        },
        onStartDragging(event, {context}) {
            const target = event.target
            this.updateStartPosition(target, context, event.pageX)
            this.updateOnStartDragging(event)
        },
        updateStartPosition(elm, context, position, offset) {
            const handlerWidth = elm.clientWidth
            const parent = this.els.startParent
            const width = max([
                handlerWidth,
                handlerWidth + position - fv(offset, this.dragOffsetX, 0)
            ])

            //parent.style.width = this.pixel2Percent((width)) //floor(width) + 'px'
            parent.style.width = floor(width) + 'px'
        },
        onEndDragging(event, {context}) {
            const target = event.target
            this.updateEndPosition(target, context, event.pageX)
            this.updateOnEndDragging(event)
        },
        updateEndPosition(elm, context, position, offset) {
            const parent = this.els.endParent
            const handlerWidth = elm.clientWidth
            const contextWidth = context.clientWidth
            const width = max([
                handlerWidth,
                (contextWidth - position) + (handlerWidth - fv(offset, this.dragOffsetX, 0))
            ])
            // parent.style.width = this.pixel2Percent((width)) //floor(width) + 'px'
            parent.style.width = floor(width) + 'px'
        },
        onSelectedDragging(event) {
            // return
            // @todo: Disabled implementation need fix for change size
            // let dx = event.delta?.x || 0
            // const startHandlerWidth = this.els.start.clientWidth
            // const endHandlerWidth = this.els.end.clientWidth
            // const scaleWidth = this.els.frames.width - (startHandlerWidth + endHandlerWidth)
            // const startParent = this.els.startParent
            // const startParentWidth = startParent.clientWidth
            // const endParent = this.els.endParent
            // const endParentWidth = endParent.clientWidth
            //
            // const newStartWidth = min([scaleWidth, max([startHandlerWidth, startParentWidth + dx])])
            // const newEndWidth = min([scaleWidth, max([endHandlerWidth, endParentWidth - dx])])
            // if  (newStartWidth !== startParentWidth && newEndWidth !== endParentWidth) {
            //     startParent.style.width = newStartWidth + 'px'
            //     endParent.style.width = newEndWidth + 'px'
            //     this.calc()
            //     this.updateOnSelectedDragging(event)
            // }
        },
        defineDrag(elm, context, started, moving, ended, options) {
            const vm = this
            options = {...options || {}, context}
            interact(elm).styleCursor(false).draggable({
                origin: context,
                inertia: true,
                startAxis: 'x',
                lockAxis: 'x',
                autoScroll: true,
                styleCursor: false,
                listeners: {
                    start(event) {
                        vm.dragOffsetX = event.pageX - event.target.offsetLeft
                        started?.call(vm, event, options)
                    },
                    move(event) {
                        moving?.call(vm, event, options)
                    },
                    end(event) {
                        vm.dragOffsetX = 0
                        ended?.call(vm, event, options)
                    },
                },
                modifiers: [
                    interact.modifiers.restrict({
                        restriction: context
                    })
                ]
            })
        },

        initDraggers() {
            const context = this.els.context
            const draggers = ['start', 'end', 'selected']
            _.forOwn(draggers, name => {
                const on = _.camelCase(`on_${name}`)
                const started = this[`${on}Draggable`]
                const moving = this[`${on}Dragging`]
                const ended = this[`${on}Dragged`]
                this.defineDrag(this.els[name], context, started, moving, ended)
            })
        },
    }
}
